import type { BetSlipState } from '../../types/betSlip';

const errorDismissed = (state: BetSlipState): BetSlipState => ({
  ...state,
  errorMessage: undefined
});

export default errorDismissed;
